import { render, staticRenderFns } from "./LogoVideo.vue?vue&type=template&id=c677052e&scoped=true&"
import script from "./LogoVideo.vue?vue&type=script&lang=js&"
export * from "./LogoVideo.vue?vue&type=script&lang=js&"
import style0 from "./LogoVideo.vue?vue&type=style&index=0&id=c677052e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c677052e",
  null
  
)

export default component.exports